// @ngInject
export function scrollIfDirective($timeout: ng.ITimeoutService, $parse: ng.IParseService): ng.IDirective {
  return {
    restrict: "A",
    link: function (scope: ng.IScope, scrollContainer: ng.IAugmentedJQuery, attrs: any) {
      let model = $parse(attrs.scrollIf);
      scope.$watch(model, (value) => {
        $timeout(() => {
          let scrollToElement = scrollContainer.find(`.${attrs.scrollTo}`);
          if (scrollToElement.length) {
            if (
              scrollContainer.offset().top < scrollToElement.offset().top &&
              scrollContainer.offset().top + scrollContainer.height() > scrollToElement.offset().top &&
              attrs.scrollTop == "always"
            ) {
              // when scroll top attribute is set to always, if an element is present in view, this would scroll it to the top always.
              // Irrespective of the fact that its already in view.
              scrollContainer.scrollTop(
                scrollContainer.scrollTop() + scrollToElement.offset().top - scrollContainer.offset().top
              );
            } else if (scrollContainer.offset().top > scrollToElement.offset().top) {
              // if scrolling/navigating top, this checks if the previous node is in view or not.
              // If not, this scrolls the container so that the element is just in view and top of scrolling container.
              scrollContainer.scrollTop(
                scrollContainer.scrollTop() - (scrollContainer.offset().top - scrollToElement.offset().top)
              );
            } else if (
              scrollContainer.offset().top + scrollContainer.height() <
              scrollToElement.offset().top + scrollToElement.outerHeight()
            ) {
              // if scrolling/navigating bottom, this checks if the next node is in view or not.
              // If not, this scrolls the container so that the element is at the top of scrolling container or maximum possible.
              scrollContainer.scrollTop(
                scrollContainer.scrollTop() + scrollToElement.offset().top - scrollContainer.offset().top
              );
            }
          } else {
            let scrollvalue = attrs.scrollValue;
            if (scrollvalue && scrollvalue > 0) {
              scrollContainer.scrollTop(scrollvalue);
            } else {
              // scroll to the top of container
              scrollContainer.scrollTop(0);
            }
          }
        }, 0);
      });
    }
  };
}
